module.exports = __webpack_public_path__ + "img/Butterfly_00171.bf9c4a0f.png";